import type { BranchPermission, ModuleKey } from '../../../../shell/session/store/sessionTypes';
import { branchPermissionsFromPreset } from './permissionPreview';
import type { RolePreset } from './EmployeeRolePresets';
import { MODULE_SHORT_LABELS_ES } from './permissionUiLabels';
import { permissionLevelFromTriple } from '../../../store/useEmployeesStore';
import { permissionLevelShortLabel } from './permissionLevelOptions';

/** Resumen corto de cambios al aplicar un preset sobre permisos actuales. */
export function describePresetPermissionDiff(
  current: BranchPermission[],
  preset: RolePreset,
  visibleModules: readonly ModuleKey[]
): string {
  const next = branchPermissionsFromPreset(preset, visibleModules);
  const changes: string[] = [];

  for (const module of visibleModules) {
    const before = current.find((p) => p.module === module);
    const after = next.find((p) => p.module === module);
    if (!before || !after) continue;

    const beforeLevel = permissionLevelShortLabel(
      module,
      permissionLevelFromTriple({
        canView: before.canView,
        canEdit: before.canEdit,
        canVoid: before.canVoid ?? false,
        canDiscount: before.canDiscount ?? false,
        canManageAgenda: before.canManageAgenda ?? false,
      })
    );
    const afterLevel = permissionLevelShortLabel(
      module,
      permissionLevelFromTriple({
        canView: after.canView,
        canEdit: after.canEdit,
        canVoid: after.canVoid ?? false,
        canDiscount: after.canDiscount ?? false,
        canManageAgenda: after.canManageAgenda ?? false,
      })
    );

    if (beforeLevel !== afterLevel) {
      const name = MODULE_SHORT_LABELS_ES[module] ?? module;
      changes.push(`${name} ${beforeLevel}→${afterLevel}`);
    }
  }

  if (changes.length === 0) {
    return 'El rol elegido coincide con los permisos actuales en esta sucursal.';
  }

  const head = changes.slice(0, 6).join(', ');
  return `Cambios: ${head}${changes.length > 6 ? '…' : ''}.`;
}
